import { render, staticRenderFns } from "./contact-single-details.vue?vue&type=template&id=77b201f6&"
import script from "./contact-single-details.vue?vue&type=script&lang=js&"
export * from "./contact-single-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports